
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ChatProvider } from './contexts/ChatContext';
import { AuraPointsProvider } from './contexts/AuraPointsContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as SonnerToaster } from '@/components/ui/sonner';
import Layout from './components/Layout';
import Index from './pages/Index';
import Chat from './pages/Chat';
import Auth from './pages/Auth';
import About from './pages/About';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import AuraPointsPage from './pages/AuraPointsPage';
import NotificationsPage from './pages/NotificationsPage';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import NotFound from './pages/NotFound';
import LiveChat from './pages/LiveChat';
import './App.css';

function App() {
  // Register service worker for better performance
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', function() {
        navigator.serviceWorker.register('/service-worker.js').then(
          function(registration) {
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
          },
          function(err) {
            console.log('ServiceWorker registration failed: ', err);
          }
        );
      });
    }
  }, []);
  
  return (
    <ThemeProvider>
      <AuthProvider>
        <LanguageProvider>
          <AuraPointsProvider>
            <NotificationProvider>
              <ChatProvider>
                <Router>
                  <Routes>
                    <Route path="/" element={<Layout />}>
                      <Route index element={<Index />} />
                      <Route path="about" element={<About />} />
                      <Route path="profile" element={<ProfilePage />} />
                      <Route path="settings" element={<SettingsPage />} />
                      <Route path="points" element={<AuraPointsPage />} />
                      <Route path="notifications" element={<NotificationsPage />} />
                      <Route path="terms" element={<Terms />} />
                      <Route path="privacy" element={<Privacy />} />
                      <Route path="login" element={<Auth mode="login" />} />
                      <Route path="signup" element={<Auth mode="signup" />} />
                    </Route>
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/livechat" element={<LiveChat />} />
                    <Route path="/404" element={<NotFound />} />
                    {/* Redirect /features to /about since we're combining them */}
                    <Route path="/features" element={<Navigate to="/about" replace />} />
                    <Route path="*" element={<Navigate to="/404" replace />} />
                  </Routes>
                </Router>
              </ChatProvider>
            </NotificationProvider>
          </AuraPointsProvider>
        </LanguageProvider>
      </AuthProvider>
      <Toaster />
      <SonnerToaster />
    </ThemeProvider>
  );
}

export default App;
